/**
 * @typedef {Object} MouseEvent
 */

/**
 * to make the navigation work
 */
export class Navigation {
    /**
     * Add event handlers for navigation
     *
     * @param {jQuery|HTMLElement} element - the navigation element
     * @constructor
     */
    constructor(element) {
        this.element = $(element);
        this.navigationButton = $('.menu-toggler');
        this.mainNav = $('.main-nav');
        this.subNav = $('.sub-nav');
        this.indicationBar = this.mainNav.next('.indication');
        this.contentOverlay = $('.content-overlay');
        this.body = $('body');
        this.animating = false;

        this.addEventHandlers();
    }

    /**
     * @returns {string} - the name of the class, used for initialization check
     */
    static get className() {
        return 'Navigation';
    }

    static getSelector() {
        return 'nav[role=navigation]';
    }

    /**
     * toggle visibility of the sub navigation inside the subnav
     *
     * @param {MouseEvent} event - the click event
     * @returns {void}
     */
    static toggleSubSubNav(event) {
        $(event.target).closest('li').toggleClass('expanded').find('ul').slideToggle(300);
        event.preventDefault();
    }

    /**
     * add all event handlers
     *
     * @returns {void}
     */
    addEventHandlers() {
        this.navigationButton.on('click', () => this.toggleNavigation());
        this.contentOverlay.on('click', () => this.toggleNavigation());

        this.mainNav[0].addEventListener('click', e => {
            const target = $(e.target);
            if (target.is('a') || target.closest('a').length) {
                this.setSubNav(e);
            }
            e.stopPropagation();
        }, true);

        this.subNav.on('click', '.sub-toggler', e => Navigation.toggleSubSubNav(e));
        $(window).on('resize', () => this.positionNavigationBar());
    }

    /**
     * show the subnav based on the clicked main nav item
     *
     * @param {MouseEvent} event - the click event
     * @returns {void}
     */
    setSubNav(event) {
        this.mainNav.children('.current').removeClass('current');
        this.subNav.children('.current').removeClass('current');

        const index = $(event.target).closest('li').addClass('current').index();
        this.subNav.children().eq(index).addClass('current');

        this.positionNavigationBar();
        event.preventDefault();
    }

    /**
     * resets the indication bar to the original position
     *
     * @returns {void}
     */
    positionNavigationBar() {
        const current = this.mainNav.find('.current a');

        this.indicationBar.css({
            'width': current.width(),
            'left': current.offset().left - this.mainNav.offset().left
        });
    }

    /**
     * Hide the navigation from the DOM and remove event listener
     *
     * @returns {void}
     */
    fullyHideNavigation() {
        this.animating = false;
        this.element[0].style.display = 'none';
        this.contentOverlay.hide();

        this.element.off('transitionend webkitTransitionEnd');
    }

    /**
     * hide the navigation and remove it from dom after transition
     *
     * @returns {void}
     */
    hideNavigation() {
        this.animating = true;

        this.body.removeClass('menu-opened');
        this.element.on('transitionend webkitTransitionEnd', () => this.fullyHideNavigation());
    }

    /**
     * show the navigation
     *
     * @returns {void}
     */
    showNavigation() {
        this.animating = true;

        this.element[0].style.display = 'block';
        this.contentOverlay.show();
        this.positionNavigationBar();

        // slight delay for css tranistion
        window.setTimeout(() => this.body.addClass('menu-opened'), 10);
        this.element.on('transitionend webkitTransitionEnd', () => this.animating = false);
    }

    /**
     * show or hide the navigation if it isn't animating
     *
     * @returns {void}
     */
    toggleNavigation() {
        if (!this.animating) {
            if (!this.body.hasClass('menu-opened')) {
                this.showNavigation();
            } else {
                this.hideNavigation();
            }
        }
    }
}


